import { connect } from 'react-redux'
import { DeliveryChoiceComponent } from './DeliveryChoiceComponent'
import {
    fetchRestaurant,
    setCollectMode,
    removeProductFromCart
} from 'shared/store/ecommerce/order'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import { restaurantServices } from 'shared/utils'
import { push } from 'connected-react-router'
import type { CouponForm, MetaShortDTO } from 'shared/types'
import { pageMetadata } from 'shared/store/metadata'
import { addCoupon } from 'shared/store/kingdom/privileges'
import type { PurchasableItem } from 'shared/store/ecommerce/order'

const {
    CLICK_AND_COLLECT,
    CLICK_AND_COLLECT_DRIVE,
    CLICK_AND_COLLECT_ON_SITE
} = restaurantServices

const mapStateToProps = (state: RootState) => {
    const { restaurant, products } = state.ecommerceOrderState
    const { authenticated } = state.userState
    const { search } = state.router.location
    const restaurantPageUrl = search.split('restaurant=')[1]
    const defaultValue = {
        cadAvailable: false,
        cagAvailable: false,
        casAvailable: false,
        restaurant,
        restaurantPageUrl,
        products,
        authenticated
    }

    if (!restaurant) {
        return defaultValue
    }

    const getAvailability = (service: string, status: any) =>
        restaurant.services.includes(service) &&
        (status === 'OPENED' || status === 'IMMINENT_CLOSING')

    const cadAvailable = getAvailability(
        CLICK_AND_COLLECT_DRIVE,
        restaurant.cadStatus
    )

    const cagAvailable = getAvailability(
        CLICK_AND_COLLECT,
        restaurant.cagStatus
    )

    const casAvailable = getAvailability(
        CLICK_AND_COLLECT_ON_SITE,
        restaurant.casStatus
    )

    return {
        ...defaultValue,
        cadAvailable,
        cagAvailable,
        casAvailable
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchRestaurant: (pathUrl: string) => d(fetchRestaurant(pathUrl)),
    setCollectMode: (collectMode: string) => d(setCollectMode(collectMode)),
    pageMetadata: (payload: MetaShortDTO) => d(pageMetadata(payload)),
    navigate: (to: string) => d(push(to)),
    addCoupon: (form: CouponForm) => d(addCoupon(form)),
    removeProductFromCart: (product: PurchasableItem) =>
        d(removeProductFromCart(product))
})

const DeliveryChoice = connect(
    mapStateToProps,
    mapDispatchToProps
)(DeliveryChoiceComponent)

export { DeliveryChoice }
